<template>
  <div id="app" class="py-5 my-5">
    <!-- <div class="fixed height-[136px] shadow-lg w-full bg-white z-10">
      Sample header
    </div>
    <div v-for="i in 10">
      <h1 class="text-2xl p-10">Test Content</h1>
    </div> -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
